import { render, staticRenderFns } from "./IpoAllocatedSummaries.vue?vue&type=template&id=7360b6a3&scoped=true"
import script from "./IpoAllocatedSummaries.vue?vue&type=script&lang=js"
export * from "./IpoAllocatedSummaries.vue?vue&type=script&lang=js"
import style0 from "./IpoAllocatedSummaries.vue?vue&type=style&index=0&id=7360b6a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360b6a3",
  null
  
)

export default component.exports